import * as React from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import finance from '../../images/sideBar/coins-stacked.svg';
import HR from '../../images/sideBar/user.svg';
import dashboard from '../../images/sideBar/home-line.svg';
import investorRelation from '../../images/sideBar/switch.svg';
import compliance from '../../images/sideBar/file-check.svg';
import shield from '../../images/sideBar/shield.svg';
import { router } from 'src/router';
import { useLocation, useNavigate } from 'react-router';
import { Typography } from '@mui/material';
import useAuth from 'src/hooks/useAuth';

export default function NestedList({ isSelected, onReset }) {
  const [isOpen, setIsOpen] = React.useState('');

  const loc = useLocation();

  const [selectedList, setSelectedList] = React.useState({
    list: '',
    sub: null
  });

  //TODO(86bvxzryv): expand it again if 'investor relation' has more nested view
  // const [openFour, setOpenFour] = React.useState(false);
  const navigate = useNavigate();
  const { setPreventBack, isBack } = useAuth();

  React.useEffect(() => {
    if (isSelected && selectedList.list) {
      setSelectedList({
        list: '',
        sub: null
      });
    }
  }, [isSelected]);

  React.useEffect(() => {
    if (selectedList.list) {
      onReset();
    }
  }, [selectedList.list]);
  const route = router;
  const handleClickOne = (list) => {
    setSelectedList({
      list,
      sub: ''
    });
  };
  const handleClickTwo = (list) => {
    setSelectedList({
      list,
      sub: ''
    });

    setIsOpen('HR');
  };
  const handleClickThree = (list) => {
    setSelectedList({
      list,
      sub: ''
    });
  };
  const handleClickFour = () => {
    setIsOpen('investorRelation');

    checkChangeRoute(null, 'investorRelation', '/investorRelations');
  };
  const handleClickFive = (list) => {
    setSelectedList({
      list,
      sub: ''
    });
  }

  const checkChangeRoute = (index, list, item) => {
    // Your logic to check for unsaved changes
    if (loc.pathname === '/employees/create' && isBack) {
      if (
        window.confirm(
          'If you leave this page, all data will be lost. Do you want to proceed?'
        )
      ) {
        // Proceed with route change

        setSelectedList({
          list: list,
          sub: index
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        item && navigate(item?.route ?? item);
      }
    } else {
      // Proceed with route change
      window.history.pushState(null, null, window.location.pathname);
      setSelectedList({
        list: list,
        sub: index
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      item && navigate(item?.route ?? item);
    }
  };

  return (
    <>
      <List
        component="nav"
        className="w-full h-[100%]"
        aria-labelledby="nested-list-subheader"
      >
        <ListItemButton
          className="m-0"
          alignItems="center"
          sx={{
            mb: 1,
            borderRadius: 2,
            background:
              selectedList.list === 'Drafts'
                ? 'rgba(0, 0, 0, 0.04)'
                : 'transparent'
          }}
          onClick={() => {
            checkChangeRoute(null, 'Drafts', '/');
          }}
        >
          <img className="mr-2 w-6 h-6" src={dashboard} />
          <ListItemText
            primaryTypographyProps={{
              fontSize: 16,
              fontWeight: '600',
              color: '#344054'
            }}
            primary="Dashboard"
          />
        </ListItemButton>
        <ListItemButton
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mb: 1,
            borderRadius: 2,
            background:
              selectedList.list === 'Financial'
                ? 'rgba(0, 0, 0, 0.04)'
                : 'transparent'
          }}
          onClick={async () => {
            await setIsOpen('Financial');
            handleClickOne('Financial');
          }}
        >
          <div className="flex flex-row items-center">
            <img className="mr-2 w-6 h-6" src={finance} />

            <Typography
              fontWeight={'600'}
              color="#344054"
              fontSize={16}
              className="bold  text-lg"
            >
              Finance
            </Typography>
          </div>
          {isOpen == 'Financial' ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={isOpen == 'Financial'} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {[
              { route: '/revnueModel', label: 'Revenue Lines' },
              { route: '/budget', label: 'Budget' },
              { route: '/profiteAndLose', label: 'P&L' },

              { route: '/finance', label: 'Financial Model' },
              { route: '/valuation', label: 'Valuation' }
            ].map((item, index) => (
              <ListItemButton
                key={Math.random().toString()}
                sx={{
                  borderRadius: 2,
                  ':hover': 'none',
                  mb: item.route == '/valuation' ? 1 : 0,

                  pl: 6,
                  background:
                    selectedList.sub === index &&
                    selectedList.list === 'Financial'
                      ? 'rgba(0, 0, 0, 0.04)'
                      : 'transparent'
                }}
                onClick={() => {
                  checkChangeRoute(index, 'Financial', item);
                }}
              >
                <ListItemText
                  primaryTypographyProps={{
                    fontSize: 16,
                    fontWeight: '600',
                    color: '#344054'
                  }}
                  className=" bold  text-lg text-[#344054]"
                  primary={item.label}
                />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
        <ListItemButton
          sx={{
            mb: 1,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            background:
              selectedList.list === 'HR' ? 'rgba(0, 0, 0, 0.04)' : 'transparent'
          }}
          onClick={async () => {
            handleClickTwo('HR');
          }}
        >
          <div className="flex flex-row items-center">
            <img className="mr-2 w-6 h-6" src={HR} />

            <Typography
              fontWeight={'600'}
              color="#344054"
              fontSize={16}
              className="bold  text-lg"
            >
              HR
            </Typography>
          </div>
          {isOpen == 'HR' ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={isOpen == 'HR'} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {[
              { route: '/departments', label: 'Departments' },
              { route: '/employees', label: 'Employees' },
              { route: '/organizationChart', label: 'Organization Chart' }
            ].map((item, index) => (
              <ListItemButton
                classes={'MMMM'}
                key={Math.random().toString()}
                sx={{
                  ':hover': 'none',
                  mb: item.route == '' ? 1 : 0,
                  borderRadius: 2,
                  pl: 6,
                  background:
                    selectedList.sub === index && selectedList.list === 'HR'
                      ? 'rgba(0, 0, 0, 0.04)'
                      : 'transparent'
                }}
                onClick={() => {
                  checkChangeRoute(index, 'HR', item);
                }}
              >
                <ListItemText
                  primaryTypographyProps={{
                    fontSize: 16,
                    fontWeight: '600',
                    color: '#344054'
                  }}
                  className=" bold  text-lg text-[#344054]"
                  primary={item.label}
                />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
        <ListItemButton
          sx={{
            borderRadius: 2,
            mb: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            background:
              selectedList.list === 'Compliance'
                ? 'rgba(0, 0, 0, 0.04)'
                : 'transparent'
          }}
          onClick={() => {
            setIsOpen('Compliance');
            handleClickThree('Compliance');
          }}
        >
          <div className="flex flex-row items-center">
            <img className="mr-2 w-6 h-6" src={compliance} />
            <Typography
              fontWeight={'600'}
              color="#344054"
              fontSize={16}
              className="bold  text-lg"
            >
              Compliance
            </Typography>
          </div>
          {isOpen == 'Compliance' ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={isOpen == 'Compliance'} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {[
              { route: '/investment/round', label: 'Investment Rounds' },
              { route: '/capTable', label: 'Captable' },
              { route: '/esop', label: 'ESOP' }
            ].map((item, index) => (
              <ListItemButton
                key={Math.random().toString()}
                sx={{
                  ':hover': 'none',
                  borderRadius: 2,
                  mb: item.route == '/investment/round' ? 1 : 0,
                  pl: 6,
                  background:
                    selectedList.sub === index &&
                    selectedList.list === 'Compliance'
                      ? 'rgba(0, 0, 0, 0.04)'
                      : 'transparent'
                }}
                onClick={() => {
                  checkChangeRoute(index, 'Compliance', item);
                }}
              >
                <ListItemText
                  primaryTypographyProps={{
                    fontSize: 16,
                    fontWeight: '600',
                    color: '#344054'
                  }}
                  className=" bold  text-lg text-[#344054]"
                  primary={item.label}
                />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
        <ListItemButton
          sx={{
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            background:
              selectedList.list === 'investorRelation'
                ? 'rgba(0, 0, 0, 0.04)'
                : 'transparent'
          }}
          onClick={handleClickFour}
        >
          <div className="flex flex-row items-center">
            <img className="mr-2 w-6 h-6" src={investorRelation} />
            <Typography
              fontWeight={'600'}
              color="#344054"
              fontSize={16}
              className="bold  text-lg"
            >
              Investor Relation
            </Typography>
          </div>
          {/* //TODO(86bvxzryv): expand it again if 'investor relation' has more nested view */}
          {/* {openFour ? <ExpandLess /> : <ExpandMore />} */}
        </ListItemButton>
        {/* <Collapse in={openFour} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton sx={{ pl: 6 }}>
            <ListItemText primary="Starred" />
          </ListItemButton>
        </List>
      </Collapse> */}

        {/* Admin Section */}
        <ListItemButton
          sx={{
            borderRadius: 2,
            my: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            background:
              selectedList.list === 'Admin'
                ? 'rgba(0, 0, 0, 0.04)'
                : 'transparent'
          }}
          onClick={() => {
            setIsOpen('Admin');
            handleClickFive('Admin');
          }}
        >
          <div className="flex flex-row items-center">
            <img className="mr-2 w-6 h-6" src={finance} />
            <Typography
              fontWeight={'600'}
              color="#344054"
              fontSize={16}
              className="bold  text-lg"
            >
              Admin
            </Typography>
          </div>
          {isOpen == 'Admin' ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>

        <Collapse in={isOpen == 'Admin'} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {[
              { route: '/admin/pages', label: 'Pages' },
            ].map((item, index) => (
              <ListItemButton
                key={Math.random().toString()}
                sx={{
                  ':hover': 'none',
                  borderRadius: 2,
                  mb: item.route == '/permissions' ? 1 : 0,
                  pl: 6,
                  background:
                    selectedList.sub === index && selectedList.list === 'Admin'
                      ? 'rgba(0, 0, 0, 0.04)'
                      : 'transparent'
                }}
                onClick={() => {
                  checkChangeRoute(index, 'Admin', item);
                }}
              >
                <ListItemText
                  primaryTypographyProps={{
                    fontSize: 16,
                    fontWeight: '600',
                    color: '#344054'
                  }}
                  className=" bold  text-lg text-[#344054]"
                  primary={item.label}
                />
              </ListItemButton>
            ))}
          </List>
        </Collapse>
      </List>
    </>
  );
}
